//#region src/rbac/permission.ts
let Permission = /* @__PURE__ */ function(Permission) {
	Permission["ManageTeamSettings"] = "manage_team_settings";
	Permission["ViewTeamSettings"] = "view_team_settings";
	Permission["ManageMembers"] = "manage_members";
	Permission["AssignRoles"] = "assign_roles";
	Permission["ManageAdminApiKeys"] = "manage_admin_api_keys";
	Permission["CreateApps"] = "create_apps";
	Permission["DeleteApps"] = "delete_apps";
	Permission["ViewApps"] = "view_apps";
	Permission["ViewAppLogs"] = "view_app_logs";
	Permission["ViewAppConfig"] = "view_app_config";
	Permission["EditAppConfig"] = "edit_app_config";
	Permission["ManageWebhooks"] = "manage_webhooks";
	Permission["ViewActivityLog"] = "view_activity_log";
	Permission["ViewApiKeys"] = "view_api_keys";
	Permission["RotateKey"] = "rotate_key";
	/**
	* Read activity-log webhook subscriptions (list / get). Admin-only because
	* subscription metadata reveals where activity-log events are exfiltrated.
	*/
	Permission["ViewActivityLogWebhooks"] = "view_activity_log_webhooks";
	/**
	* Create / update / delete / test-fire activity-log webhook subscriptions.
	* Admin-only because subscriptions carry KMS-encrypted auth credentials and
	* route audit events to external systems.
	*/
	Permission["ManageActivityLogWebhooks"] = "manage_activity_log_webhooks";
	return Permission;
}({});
//#endregion
export { Permission };

//# sourceMappingURL=permission.js.map